import { TvTabMenuModel } from '../../../types/flo-experience'

import SpeechComp from '../../speechComp/speechComp'
import TvTab from './TvTab'

export default class TabMenu extends SpeechComp {
  private _data: TvTabMenuModel
  private _tabIndex = 0

  static _template() {
    return {
      h: 82,
      w: (w) => w,
      flex: { direction: 'row' },
      collision: true,
    }
  }

  set tabIndex(v) {
    this._tabIndex = v
  }

  get sectionText() {
    return this.data?.items.length + ' Tabs, Scroll Right To Browse'
  }

  get tabIndex() {
    return this._tabIndex
  }

  get currentTab() {
    return this.childList.getAt(this.tabIndex) as TvTab
  }

  get totalTabs() {
    return this.childList.length
  }

  set data(v: TvTabMenuModel) {
    this._data = v

    this.renderTabs(v)
  }

  get data() {
    return this._data
  }

  _getFocused() {
    return this.currentTab
  }

  _handleRight() {
    if (this.tabIndex === this.totalTabs - 1) {
      return false
    } else {
      this.currentTab.toggleTab(false)
      this._tabIndex++
      this.currentTab.toggleTab(true)
    }
  }

  _handleLeft() {
    if (this.tabIndex === 0) {
      return false
    } else {
      this.currentTab.toggleTab(false)
      this._tabIndex--
      this.currentTab.toggleTab(true)
    }
  }

  renderTabs(menu: TvTabMenuModel) {
    this.patch({
      children: menu?.items.map((item, i) => {
        return {
          type: TvTab,
          data: item,
          isSelected: i === this._tabIndex,
          tabIndex: i,
          itemIndex: i,
          totalItems: menu?.items.length,
          zIndex: this.zIndex + 1,
        }
      }),
    })
  }

  $updateFocusByHover(tab) {
    this.fireAncestors('$updateFocusByHover', this.currentTab)

    // Behavior differs from when using the keyboard. If hovered, the tab will not change automatically, as
    // it was causing a lot of issues. If the user clicks on a tab, then the tab will then only be defined
    if (tab && this._tabIndex !== tab.tabIndex) {
      this.currentTab.toggleTab(false)
      this._tabIndex = tab.tabIndex
      this.currentTab.toggleTab(true)
    }
  }
}
